import { render, staticRenderFns } from "./CompetenciesListing.vue?vue&type=template&id=32c84765"
import script from "./CompetenciesListing.vue?vue&type=script&lang=ts"
export * from "./CompetenciesListing.vue?vue&type=script&lang=ts"
import style0 from "./CompetenciesListing.vue?vue&type=style&index=0&id=32c84765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports